import React from "react";

const styles = {
  wrapper: {
    position: "relative"
  },
  label: {
    cursor: "pointer"
  },
  menu: {
    "border-radius": "4px",
    border: "1px solid #F2F2F2",
    "box-shadow":
      "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
    position: "absolute",
    bottom: "20px",
    right: "10px"
  },
  close: {
    float: "right"
  }
};
const SessionContentPopover = ({
  Label,
  onLabelClick,
  isOpen,
  children,
  menuRef
}) => {
  return (
    <div
      className={"session-content-popover"}
      style={styles.wrapper}
      ref={menuRef}
    >
      <div
        style={styles.label}
        onClick={() => {
          onLabelClick(!open);
        }}
      >
        {Label}
      </div>

      {isOpen && <div style={styles.menu}>{children}</div>}
    </div>
  );
};

export default SessionContentPopover;
